import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dropdown-specs',
  templateUrl: './dropdown-specs.component.html',
  styleUrls: ['./dropdown-specs.component.sass']
})
export class DropdownSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/singleselect-dropdown/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
